import { lazy, Suspense } from 'react';
import BlobProfile from './BlobProfile';
import { GridImagesCaption } from './GridImagesCaption';
import MessageBlobCaption from './MessageBlobCaption';
import MessageIllustration from './MessageIllustration';
import MessageIllustratedList from './MessageIllustratedList';
import MessageImageCaption from './MessageImageCaption';
import { QuoteComponent } from './QuoteComponent';
import MessageAnimation from './MessageAnimation';
import HighlightCaption from './HighlightCaption';
import { jsx as _jsx } from "react/jsx-runtime";
const messageBlobCaption = ({
  imageUrl,
  imageHeight,
  centreMessageOnMobile,
  colorThemeOption,
  captionImage,
  captionImageHeight,
  blobBleed,
  blobBleedConfig,
  shouldShowDecorativeBlob,
  imageWidth,
  blobHeight,
  showBorder,
  isCard,
  shouldUseConfigOffsetFirefox
}) => {
  return {
    component: MessageBlobCaption,
    imageUrl,
    imageHeight,
    centreMessageOnMobile,
    colorThemeOption,
    captionImage,
    captionImageHeight,
    blobBleed,
    blobBleedConfig,
    shouldShowDecorativeBlob,
    imageWidth,
    blobHeight,
    showBorder,
    isCard,
    shouldUseConfigOffsetFirefox
  };
};
const blobProfile = ({
  imageUrl,
  colorThemeOption,
  blobBleed,
  imageHeight,
  blobBleedConfig
}) => ({
  component: BlobProfile,
  imageUrl,
  colorThemeOption,
  blobBleed,
  imageHeight,
  blobBleedConfig
});
const imageMessage = ({
  imageKey,
  altText
}) => ({
  component: MessageImageCaption,
  imageKey,
  altText
});
const illustration = ({
  illustrationName,
  height,
  imageHeights,
  colorThemeOption,
  topMargin
}) => Object.assign({
  component: MessageIllustration,
  illustrationName,
  height,
  imageHeights,
  topMargin
}, colorThemeOption && {
  colorThemeOption
});
const illustratedList = ({
  illustrationName,
  height,
  isHTMLMessage,
  imageHeights,
  colorThemeOption,
  animationDelay,
  footerComponent
}) => Object.assign({
  component: MessageIllustratedList,
  illustrationName,
  height,
  isHTMLMessage,
  imageHeights
}, colorThemeOption && {
  colorThemeOption
}, {
  animationDelay,
  footerComponent
});
const animation = ({
  imageUrl,
  renderBlob,
  colorThemeOption,
  shouldShowDecorativeBlob,
  blobBleed,
  imageHeight,
  imageWidth,
  blobBleedConfig,
  loop,
  isCard,
  blobHeight,
  topMargin
}) => ({
  component: MessageAnimation,
  imageUrl,
  renderBlob,
  colorThemeOption,
  shouldShowDecorativeBlob,
  blobBleed,
  imageHeight,
  imageWidth,
  blobBleedConfig,
  loop,
  blobHeight,
  isCard,
  topMargin
});
const quote = ({
  imageUrl,
  imageHeights,
  altText
} = {}) => ({
  component: QuoteComponent,
  imageUrl,
  imageHeights,
  altText
});
const imagesInGrid = ({
  imageArray,
  bgColor
}) => ({
  component: GridImagesCaption,
  imageArray,
  bgColor
});
const highlightCaption = ({
  dataKey,
  highlightMessageKeys,
  landingPageComponent,
  illustrationName,
  height
}) => {
  return {
    component: HighlightCaption,
    landingPageComponent,
    dataKey,
    highlightMessageKeys,
    // Illustration passthrough props
    illustrationName,
    height
  };
};
const CampaignAssistantHowItWorks = /*#__PURE__*/lazy(() => import('./CampaignAssistantHowItWorks'));
const campaignAssistant = () => ({
  component: () => /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(CampaignAssistantHowItWorks, {})
  })
});
const AiBlogPosts = /*#__PURE__*/lazy(() => import('./AiBlogPosts'));
const blogGenerator = () => ({
  component: () => /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(AiBlogPosts, {})
  })
});
const AiLandingPage = /*#__PURE__*/lazy(() => import('./AiLandingPageCreator'));
const landingPageCreator = () => ({
  component: () => /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(AiLandingPage, {})
  })
});
const UseCase = /*#__PURE__*/lazy(() => import('./UseCaseContent'));
const contentUseCase = () => ({
  component: () => /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(UseCase, {})
  })
});
const CompanyDomain = /*#__PURE__*/lazy(() => import('./CompanyDomainContent'));
const contentCompanyDomain = () => ({
  component: () => /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(CompanyDomain, {})
  })
});
const CheckYourEmail = /*#__PURE__*/lazy(() => import('./CheckYourEmailContent'));
const contentCheckYourEmail = () => ({
  component: () => /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(CheckYourEmail, {})
  })
});
const InvoiceGenerator = /*#__PURE__*/lazy(() => import('./InvoiceGenerator'));
const invoiceGenerator = () => ({
  component: () => /*#__PURE__*/_jsx(Suspense, {
    children: /*#__PURE__*/_jsx(InvoiceGenerator, {})
  })
});
export const MessageTypes = {
  imagesInGrid,
  quote,
  illustration,
  illustratedList,
  imageMessage,
  blobProfile,
  messageBlobCaption,
  animation,
  highlightCaption,
  campaignAssistant,
  blogGenerator,
  landingPageCreator,
  contentUseCase,
  contentCompanyDomain,
  contentCheckYourEmail,
  invoiceGenerator
};